import React, { createContext, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { useDataModel } from '@thd-nucleus/data-sources';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { useSplitQuotesByStatus } from '../hooks/useSplitQuotesByStatus';
import { dataModel } from '../dataModels/dataModel';

export const QuotesContext = createContext();

const QuotesProvider = ({ children, maxListSize, componentId }) => {
  const { userID, svocID, role } = useThdCustomer();
  const { data, loading, error, refetch } = useDataModel('quoteList', {
    variables: {
      svocId: svocID,
      userId: role !== 'ADMIN' ? userID : null,
      pageNumber: '1',
      pageSize: '20',
      sortBy: 'createdDt',
      sortOrder: 'desc',
      quoteStatus: 'all',
    },
    ssr: false,
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
  });
  const quoteList = data?.quoteList || [];
  const quotes = quoteList?.quotes || [];

  const [selectedTab, setSelectedTab] = useState('active');
  const { activeQuotes, expiredQuotes } = useSplitQuotesByStatus(quotes);
  const hasQuotes = quotes && quotes.length > 0;
  const showTabs = activeQuotes.length > 0 && expiredQuotes.length > 0;

  const experienceContext = useContext(ExperienceContext);
  const { channel } = experienceContext;
  const isMobile = channel === 'mobile';

  const refreshQuotes = async () => {
    try {
      // Force a network request by passing fetchPolicy
      const result = await refetch({
        fetchPolicy: 'network-only'
      });

      return result;
    } catch (refetchError) {
      // eslint-disable-next-line no-console
      console.error('RefreshQuotes: Refetch failed', refetchError);
      return refetchError;
    }
  };
  return (
    <QuotesContext.Provider value={{
      quotes,
      loading,
      error,
      refreshQuotes,
      activeQuotes,
      expiredQuotes,
      hasQuotes,
      showTabs,
      selectedTab,
      setSelectedTab,
      maxListSize,
      componentId,
      isMobile
    }}
    >
      {children}
    </QuotesContext.Provider>
  );
};

QuotesProvider.propTypes = {
  children: PropTypes.node.isRequired,
  maxListSize: PropTypes.number.isRequired,
  componentId: PropTypes.string.isRequired,
};
QuotesProvider.dataModel = dataModel;

export { QuotesProvider };
